import { Component, OnInit, Input } from '@angular/core';
import { FormArray } from '@angular/forms';
import { AdvertiserInfoVO } from 'src/app/planner/interfaces/AdvertiserInfo';

@Component({
  selector: 'inventory-management',
  templateUrl: './inventory-management.component.html',
  styleUrls: ['./inventory-management.component.scss']
})
export class InventoryManagementComponent implements OnInit {

  @Input() group: any;
  @Input() formArray: FormArray;
  @Input() isNew: boolean;
  @Input() advertiserInfo: AdvertiserInfoVO;

  constructor() { }

  ngOnInit() {
  }

}
